
uniform vec2 uFrequency;
uniform float uTime; 

varying vec2 vUv;

void main(){

    vec4 modelPosition = modelMatrix * vec4(position, 1.0);
    modelPosition.z += cos(modelPosition.x * uFrequency.x + uTime) * 0.4;
    //updating the y more is not great for an aurora borealis I think
    modelPosition.z +=  sin(modelPosition.y * uFrequency.y + uTime) * 0.05;


    
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;

   
    gl_Position = projectedPosition;
    vUv = uv;
}